const isEmpty = (value: any): value is null | undefined => {
  if (value === null || value === undefined) return true;

  return false;
};

export default isEmpty;
